import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם (בלי להתווכח)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה: זה פרפקציוניזם. זה לא “סטנדרט גבוה” בלבד — זה פחד."
    ],
      [
      "היום אני מזהה: זה פרפקציוניזם. זה לא “סטנדרט גבוה” בלבד — זה פחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “אני מפחד/ת לטעות — ולכן אני דורש/ת מושלם.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “אני מפחד/ת לטעות — ולכן אני דורש/ת מושלם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הדבר שאני רוצה שיהיה “מושלם” עכשיו?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם זה יהיה רק “בסדר”?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש/ה את הפחד הזה?\n[כאן אני כותב]"
    ],
      [
      "מה הדבר שאני רוצה שיהיה “מושלם” עכשיו?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם זה יהיה רק “בסדר”?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש/ה את הפחד הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני לא נלחם/ת בפרפקציוניזם. אני מזהה אותו."
    ],
      [
      "סגירה",
      "היום אני לא נלחם/ת בפרפקציוניזם. אני מזהה אותו."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה + משפט: “מושלם הוא פחד בתחפושת.”",
      "פעם אחת היום: נשימה + משפט: “מושלם הוא פחד בתחפושת.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדה מול דרישה (CBT עדין)",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת: מה באמת בוחר/ת — ומה אני דורש/ת כדי לא להרגיש חשוף/ה."
    ],
      [
      "היום אני בודק/ת: מה באמת בוחר/ת — ומה אני דורש/ת כדי לא להרגיש חשוף/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “לא כל דבר רוצה להיות 100%.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “לא כל דבר רוצה להיות 100%.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה באמת נדרש פה? (מינימום אמיתי)\n[כאן אני כותב]",
      "מה הדרישה הפרפקציוניסטית מעל זה?\n[כאן אני כותב]",
      "איזו אמת עדינה קיימת כאן? (משפט אחד)\n[כאן אני כותב]"
    ],
      [
      "מה באמת נדרש פה? (מינימום אמיתי)\n[כאן אני כותב]",
      "מה הדרישה הפרפקציוניסטית מעל זה?\n[כאן אני כותב]",
      "איזו אמת עדינה קיימת כאן? (משפט אחד)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הדרישה הגבוהה היא לא הוכחה לאיכות — היא לפעמים הוכחה לפחד."
    ],
      [
      "סגירה",
      "הדרישה הגבוהה היא לא הוכחה לאיכות — היא לפעמים הוכחה לפחד."
    ]
    ),
    action: localizedGenderNode(
      "אני מגדיר/ה “מינימום אמיתי” למשימה אחת.",
      "אני מגדיר/ה “מינימום אמיתי” למשימה אחת."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הפחד מטעויות (ומה הוא אומר עליי)",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד מהטעות — בלי לתת לו לעצור אותי."
    ],
      [
      "היום אני נוגע/ת בפחד מהטעות — בלי לתת לו לעצור אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו טעות אני הכי מפחד/ת לעשות?\n[כאן אני כותב]",
      "מה אני אומר/ת לעצמי שזה אומר עליי אם אטעה?\n[כאן אני כותב]",
      "איזו אמת אחרת יכולה להיות? (טעות = …)\n[כאן אני כותב]"
    ],
      [
      "איזו טעות אני הכי מפחד/ת לעשות?\n[כאן אני כותב]",
      "מה אני אומר/ת לעצמי שזה אומר עליי אם אטעה?\n[כאן אני כותב]",
      "איזו אמת אחרת יכולה להיות? (טעות = …)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "טעות היא אירוע. לא זהות."
    ],
      [
      "סגירה",
      "טעות היא אירוע. לא זהות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום אני אומר/ת: “מותר לטעות בדרך.”",
      "פעם אחת היום אני אומר/ת: “מותר לטעות בדרך.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "דחיינות כ”הגנה”",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה: דחיינות היא לא עצלנות. היא ניסיון להגן עליי מכאב."
    ],
      [
      "היום אני מבין/ה: דחיינות היא לא עצלנות. היא ניסיון להגן עליי מכאב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא עצלן/ית. אני מפחד/ת.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא עצלן/ית. אני מפחד/ת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני דוחה עכשיו?\n[כאן אני כותב]",
      "מה הדחייה מגינה עליי ממנו? (ביקורת/בושה/כישלון/חשיפה)\n[כאן אני כותב]",
      "איזו גרסה קטנה אפשרית של התחלה?\n[כאן אני כותב]"
    ],
      [
      "מה אני דוחה עכשיו?\n[כאן אני כותב]",
      "מה הדחייה מגינה עליי ממנו? (ביקורת/בושה/כישלון/חשיפה)\n[כאן אני כותב]",
      "איזו גרסה קטנה אפשרית של התחלה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשאני מכבד/ת את הפחד — אני יכול/ה להתחיל קטן."
    ],
      [
      "סגירה",
      "כשאני מכבד/ת את הפחד — אני יכול/ה להתחיל קטן."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה 2 דקות התחלה. רק 2.",
      "אני עושה 2 דקות התחלה. רק 2."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "“או מושלם או כלום”",
    opening: localizedGenderNode(
      [
      "היום אני מזהה חשיבה קיצונית ומחזיר/ה רצף."
    ],
      [
      "היום אני מזהה חשיבה קיצונית ומחזיר/ה רצף."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “יש גם באמצע.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “יש גם באמצע.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני חושב/ת “או מושלם או כלום”?\n[כאן אני כותב]",
      "מה המחיר של הקיצוניות הזאת?\n[כאן אני כותב]",
      "איך נשמעת גרסת “באמצע”? (משפט אחד)\n[כאן אני כותב]"
    ],
      [
      "איפה אני חושב/ת “או מושלם או כלום”?\n[כאן אני כותב]",
      "מה המחיר של הקיצוניות הזאת?\n[כאן אני כותב]",
      "איך נשמעת גרסת “באמצע”? (משפט אחד)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "האמצע הוא המקום שבו חיים נבנים."
    ],
      [
      "סגירה",
      "האמצע הוא המקום שבו חיים נבנים."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת גרסת 70% למשימה אחת.",
      "אני בוחר/ת גרסת 70% למשימה אחת."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "המבקר הפנימי שמחזיק שוט",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הטון — ומפסיק/ה לתת לו להוביל."
    ],
      [
      "היום אני מזהה את הטון — ומפסיק/ה לתת לו להוביל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “הטון לא רוצה להיות אלים.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “הטון לא רוצה להיות אלים.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המבקר אומר לי כדי “לדרבן” אותי?\n[כאן אני כותב]",
      "מה זה עושה לי בגוף/בחשק?\n[כאן אני כותב]",
      "איך הייתי מדבר/ת לחבר אהוב כדי לעזור לו להתקדם?\n[כאן אני כותב]"
    ],
      [
      "מה המבקר אומר לי כדי “לדרבן” אותי?\n[כאן אני כותב]",
      "מה זה עושה לי בגוף/בחשק?\n[כאן אני כותב]",
      "איך הייתי מדבר/ת לחבר אהוב כדי לעזור לו להתקדם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שוט לא מגדל יציבות. הוא מגדל פחד."
    ],
      [
      "סגירה",
      "שוט לא מגדל יציבות. הוא מגדל פחד."
    ]
    ),
    action: localizedGenderNode(
      "אני מחליף/ה משפט אחד אלים במשפט אנושי אחד.",
      "אני מחליף/ה משפט אחד אלים במשפט אנושי אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "ניסוי התקדמות (Behavior): 10% זה ניצחון",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת פעולה קטנה — גם אם זה לא מושלם."
    ],
      [
      "היום אני מתרגל/ת פעולה קטנה — גם אם זה לא מושלם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה יעד גדול גורם לי להיתקע?\n[כאן אני כותב]",
      "מה 10% ממנו שאני יכול/ה לעשות היום?\n[כאן אני כותב]",
      "מה אני רוצה להוכיח לעצמי דרך 10%?\n[כאן אני כותב]"
    ],
      [
      "איזה יעד גדול גורם לי להיתקע?\n[כאן אני כותב]",
      "מה 10% ממנו שאני יכול/ה לעשות היום?\n[כאן אני כותב]",
      "מה אני רוצה להוכיח לעצמי דרך 10%?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא בוחר/ת/ה מוטיבציה כדי להתחיל. אני בוחר/ת/ה התחלה."
    ],
      [
      "סגירה",
      "אני לא בוחר/ת/ה מוטיבציה כדי להתחיל. אני בוחר/ת/ה התחלה."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה את ה־10% שלי. וזה הכול.",
      "אני עושה את ה־10% שלי. וזה הכול."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשאת אי־ודאות (ACT): “אולי זה לא יצא מושלם — ואני עושה”",
    opening: localizedGenderNode(
      [
      "היום אני מתאמן/ת על זה: לעשות למרות אי־ודאות."
    ],
      [
      "היום אני מתאמן/ת על זה: לעשות למרות אי־ודאות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אי־ודאות היא מחיר של חיים.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אי־ודאות היא מחיר של חיים.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד/ת שיקרה אם זה לא יהיה מושלם?\n[כאן אני כותב]",
      "תרגול דקה אחת: אני נותן/ת לפחד להיות כאן, בלי פעולה של תיקון. מה קרה אחרי הדקה?\n[כאן אני כותב]",
      "מה למדתי על הגל?\n[כאן אני כותב]"
    ],
      [
      "מה אני מפחד/ת שיקרה אם זה לא יהיה מושלם?\n[כאן אני כותב]",
      "תרגול דקה אחת: אני נותן/ת לפחד להיות כאן, בלי פעולה של תיקון. מה קרה אחרי הדקה?\n[כאן אני כותב]",
      "מה למדתי על הגל?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני אמיץ/ה לא כי אין פחד — אלא כי אני פועל/ת איתו."
    ],
      [
      "סגירה",
      "אני אמיץ/ה לא כי אין פחד — אלא כי אני פועל/ת איתו."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“מה יגידו” והבושה",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה שפרפקציוניזם לפעמים הוא פחד מחשיפה."
    ],
      [
      "היום אני מבין/ה שפרפקציוניזם לפעמים הוא פחד מחשיפה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מי “יושב לי בראש” כשאני רוצה להיות מושלם/ת?\n[כאן אני כותב]",
      "מה אני מפחד/ת שישפטו בי?\n[כאן אני כותב]",
      "איזו אמת עדינה אני בוחר/ת עליי היום?\n[כאן אני כותב]"
    ],
      [
      "מי “יושב לי בראש” כשאני רוצה להיות מושלם/ת?\n[כאן אני כותב]",
      "מה אני מפחד/ת שישפטו בי?\n[כאן אני כותב]",
      "איזו אמת עדינה אני בוחר/ת עליי היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להיות מושלם/ת כדי להיות ראוי/ה."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להיות מושלם/ת כדי להיות ראוי/ה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “אני עושה בשבילי, לא בשביל הוועדה.”",
      "פעם אחת היום: “אני עושה בשבילי, לא בשביל הוועדה.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "חמלה במקום לחץ (Self-Compassion)",
    opening: localizedGenderNode(
      [
      "היום אני מחזיק/ה את עצמי כמו אדם שאני אוהב/ת."
    ],
      [
      "היום אני מחזיק/ה את עצמי כמו אדם שאני אוהב/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אפשר להתקדם בלי לדרוך עליי.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אפשר להתקדם בלי לדרוך עליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי אומר/ת לחבר אהוב שקפוא מפרפקציוניזם?\n[כאן אני כותב]",
      "איזה משפט אחד אני מוכן/ה להגיד לעצמי?\n[כאן אני כותב]",
      "איפה הכי קשה לי להיות רך/ה עם עצמי?\n[כאן אני כותב]"
    ],
      [
      "מה הייתי אומר/ת לחבר אהוב שקפוא מפרפקציוניזם?\n[כאן אני כותב]",
      "איזה משפט אחד אני מוכן/ה להגיד לעצמי?\n[כאן אני כותב]",
      "איפה הכי קשה לי להיות רך/ה עם עצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "חמלה לא מורידה סטנדרט — היא מורידה פחד."
    ],
      [
      "סגירה",
      "חמלה לא מורידה סטנדרט — היא מורידה פחד."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן + המשפט הרך שלי פעם אחת.",
      "יד על חזה/בטן + המשפט הרך שלי פעם אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "גבולות לזמן וללופים",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול לליטוש אינסופי."
    ],
      [
      "היום אני שם גבול לליטוש אינסופי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מספיק זה גם החלטה.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מספיק זה גם החלטה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מתקע/ת בליטוש בלי סוף?\n[כאן אני כותב]",
      "מה גבול זמן קטן שאני מוכן/ה לשים? (15–30 דק’)\n[כאן אני כותב]",
      "מה הפחד אם אעצור בזמן?\n[כאן אני כותב]"
    ],
      [
      "איפה אני מתקע/ת בליטוש בלי סוף?\n[כאן אני כותב]",
      "מה גבול זמן קטן שאני מוכן/ה לשים? (15–30 דק’)\n[כאן אני כותב]",
      "מה הפחד אם אעצור בזמן?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא הגנה על החיים, לא ויתור על איכות."
    ],
      [
      "סגירה",
      "גבול הוא הגנה על החיים, לא ויתור על איכות."
    ]
    ),
    action: localizedGenderNode(
      "אני עובד/ת בזמן קצוב — ועוצר/ת בזמן.",
      "אני עובד/ת בזמן קצוב — ועוצר/ת בזמן."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "תרגול “גרסה ראשונה”",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להוציא “גרסה 1” לעולם בלי להתנצל."
    ],
      [
      "היום אני מתרגל/ת להוציא “גרסה 1” לעולם בלי להתנצל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הדבר שאני מחכה “שיהיה מוכן” כבר זמן?\n[כאן אני כותב]",
      "מה נחשב “גרסה 1” מינימלית?\n[כאן אני כותב]",
      "מה יקרה אם אוציא גרסה 1? (באמת)\n[כאן אני כותב]"
    ],
      [
      "מה הדבר שאני מחכה “שיהיה מוכן” כבר זמן?\n[כאן אני כותב]",
      "מה נחשב “גרסה 1” מינימלית?\n[כאן אני כותב]",
      "מה יקרה אם אוציא גרסה 1? (באמת)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גרסה 1 היא לא בושה. היא התחלה."
    ],
      [
      "סגירה",
      "גרסה 1 היא לא בושה. היא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "אני מוציא/ה משהו אחד כגרסה 1 (אפילו לעצמי).",
      "אני מוציא/ה משהו אחד כגרסה 1 (אפילו לעצמי)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבנות זהות של מתקדמ/ת",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת להיות אדם שמתקדם — לא אדם שמוכיח."
    ],
      [
      "היום אני בוחר/ת להיות אדם שמתקדם — לא אדם שמוכיח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בדרך.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בדרך.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך אני רוצה להוביל אותי? (צמיחה/אמת/שקט/אומץ)\n[כאן אני כותב]",
      "איזה הרגל קטן משרת את הערך הזה השבוע?\n[כאן אני כותב]",
      "מה אני מבטיח/ה לעצמי ביום שאני נתקע/ת?\n[כאן אני כותב]"
    ],
      [
      "איזה ערך אני רוצה להוביל אותי? (צמיחה/אמת/שקט/אומץ)\n[כאן אני כותב]",
      "איזה הרגל קטן משרת את הערך הזה השבוע?\n[כאן אני כותב]",
      "מה אני מבטיח/ה לעצמי ביום שאני נתקע/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא מחכה להיות מושלם/ת כדי להיות אני."
    ],
      [
      "סגירה",
      "אני לא מחכה להיות מושלם/ת כדי להיות אני."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן/ת צעד קטן לשבוע הבא — ומצמיד/ה אותו ליומן.",
      "אני מתכנן/ת צעד קטן לשבוע הבא — ומצמיד/ה אותו ליומן."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה (לצאת מהכלא)",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת מסע בלי “ניצחון”. עם חופש."
    ],
      [
      "היום אני מסיים/ת מסע בלי “ניצחון”. עם חופש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בוחר/ת חיים.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בוחר/ת חיים.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבנתי על הפרפקציוניזם שלי?\n[כאן אני כותב]",
      "מה השתנה בי קצת במסע הזה?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):\n[כאן אני כותב]"
    ],
      [
      "מה הבנתי על הפרפקציוניזם שלי?\n[כאן אני כותב]",
      "מה השתנה בי קצת במסע הזה?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מבטל/ת את הרצון לאיכות.",
      "אני מבטל/ת את האלימות שמחזיקה אותי תקוע/ה.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מבטל/ת את הרצון לאיכות.",
      "אני מבטל/ת את האלימות שמחזיקה אותי תקוע/ה.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת פעולה אחת שמסמלת “התחלתי”: 10 דקות עבודה / שליחה / פתיחת קובץ.",
      "אני בוחר/ת פעולה אחת שמסמלת “התחלתי”: 10 דקות עבודה / שליחה / פתיחת קובץ."
    ),
  },
].map(buildNormalizedDay);

export const perfectionismFearOfMistakesProcrastinationBlueprintHe = buildNormalizedPilotBlueprint({
  id: "perfectionism_fear_of_mistakes_procrastination_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "perfectionism_fear_of_mistakes_procrastination",
  category: "general",
  journeyName: {
    he: "פרפקציוניזם שמוביל לפחד מטעויות ודחיינות",
    en: "Perfectionism Leading to Fear of Mistakes and Procrastination",
    es: "Perfeccionismo que lleva al miedo a equivocarse y a la procrastinación",
  },
  days,
});

export default perfectionismFearOfMistakesProcrastinationBlueprintHe;
